import PoolDescription, { I18N_CONTEXT } from './create_description'
import { getI18n } from 'client/i18n'
import { reduxForm } from 'redux-form'
import { DESCRIPTION_LENGTH } from 'shared/lengths'
import formUtils from 'lib/form_utils'
import { length } from 'lib/validators'
import { push } from 'react-router-redux'

import { NEW_CAMPAIGN_ID, setData } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'

const i18n = getI18n(I18N_CONTEXT)

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)

  return {
    gradientColor: campaign.gradient_color,
    backgroundImage: campaign.background_image,
    backgroundPan: campaign.background_pan,
    isAndroid:
      state.device_info.isMobile && state.device_info.deviceOS === 'Android',
    initialValues: {
      description: campaign.description,
    },
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onSubmit(formValues) {
      dispatch(
        setData(NEW_CAMPAIGN_ID, { description: formValues.description })
      )
      dispatch(
        push({ pathname: `${GLOBAL_CONSTS.REQUEST_URI}/c/create/preview` })
      )
    },
  }
}

export default reduxForm(
  {
    form: 'create_description',
    destroyOnUnmount: false,
    fields: ['description'],
    touchOnBlur: false,
    touchOnChange: true,
    validate: length(
      'description',
      DESCRIPTION_LENGTH,
      i18n('description_too_long', {
        maxLength: DESCRIPTION_LENGTH,
      })
    ),
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(PoolDescription))
